/**
 * SHOWCASE-ONLY hardcoded totals.
 *
 * Used only when `B.PAYMENT_TERMS_SHOWCASE` / `VITE_PAYMENT_TERMS_SHOWCASE` is
 * on, via `showcaseDisplay()` in paymentTermsDisplay.ts. Live databag views
 * must not import these objects — they render "Missing" when the API has no
 * value instead of falling back here.
 *
 * Occurrence counts below are UI render sites (not type/import lines).
 */

const CURRENCY = 'EUR';

/** SHOWCASE-ONLY KPI totals. Live uses GET …/summary/ + FE ratios, else Missing. */
export const PT_KPIS = {
    // 7 sites: table (3) + drawer + landscape + harmonisation + display
    currency: CURRENCY,
    // Opportunities KPI "Total spend (period)"
    totalPositiveSpend: 1908197544.02,
    // Opportunities KPI "Weighted avg payment term"
    weightedAvgTerm: 55.2,
    // Scope strip "Term coverage"
    termCoveragePct: 1.0,
    // Opportunities KPI "Immediate payment exposure"
    immediateExposure: 21654384.54,
    immediateExposurePct: 0.0113,
    // Opportunities KPI "Spend below target terms" + landscape footnote
    spendBelowTarget: 1031283549.95,
    spendBelowTargetPct: 0.5404,
    // Opportunities WC KPI, landscape footnote
    wcOpportunity: 58460303.76,
    // Opportunities WC range min, trend footnote
    quickWinOpportunity: 21730163.09,
    // Opportunities + Harmonisation "Suppliers meeting policy"
    suppliersMeetingPolicyPct: 0.2273,
    // Scope strip + landscape header
    supplierCount: 4760,
    // Scope strip "Transactions"
    transactionCount: 155000,
    // Harmonisation boxed KPI
    suppliersWithMultipleTerms: 1905,
    multiTermSpend: 1724293721.13,
    multiTermQuickWin: 21719166.54,
    suppliersMeetingPolicy: 1082,
    distinctTermVariants: 12,
    // Landscape non-standard callout
    nonStandardTermSpend: 936662508.60,
};

/** SHOWCASE-ONLY policy copy. Live uses summary.policy + mapping.approved. */
export const PT_POLICY = {
    // Scope strip, KPI help, landscape, harmonisation, drawer, trend target line
    targetTermDays: 60,
    // Landscape header + non-standard callout
    approvedTerms: [0, 30, 45, 60, 90],
    // Page footer caption
    scopeNote: 'Third-party suppliers only · intercompany excluded · Aug 2025 – Oct 2026 on posting date · supplier legal-parent level',
};

/** SHOWCASE-ONLY analysis window. Live uses summary.trend first/latest month. */
export const PT_PERIOD = {
    // Scope strip + Opportunities spend help + Trend header
    from: 'Aug 2025',
    to: 'Oct 2026',
    label: '15 months',
};

/** SHOWCASE-ONLY long tail beyond the top-250 table. Live: count = total − loaded rows. */
export const PT_LONG_TAIL = {
    // Opportunities table hint
    count: 4510,
    spend: 1178661392.70,
    wcOpportunity: 34735341.85,
    quickWinOpportunity: 8538787.73,
    invoiceCount: 140841,
};
